function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.2688 8.80285L11.9878 0.521808C11.6224 0.156468 11.0135 0.156468 10.6238 0.521808L2.26972 8.90027C0.053323 11.1167 0.053323 14.7701 2.26972 16.9865C3.39009 18.1068 4.85145 18.667 6.31281 18.667C7.38448 18.667 8.45614 18.3504 9.40602 17.7659L7.28705 22.4909C7.09221 22.9293 7.40883 23.3921 7.8716 23.3921H14.7156C15.1784 23.3921 15.495 22.905 15.3002 22.4909L13.1812 17.7415C14.1311 18.3504 15.2028 18.667 16.2988 18.667C17.8088 18.667 19.3189 18.0825 20.4393 16.889C22.607 14.6239 22.4852 11.0192 20.2688 8.80285Z",
  fill: "white"
});

function SvgCasinoVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasinoVertical);
export default __webpack_public_path__ + "static/media/casinoVertical.17d2c571.svg";
export { ForwardRef as ReactComponent };